import { ErrorMessage } from "@hookform/error-message";
import * as moment from "moment";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
  UncontrolledDropdown,
} from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  Row,
} from "../../components/Component";
import Table from "../../components/react-table/Table";
import { DELETE, GET, POST, PUT } from "../../helper/api";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";


const DEFAULT_WAREHOUSE = {
  id: null,
  name: null,
  address: null,
  isOutsourcingWarehouse: false,
};

const WarehouseManager = () => {
  const [loading, setLoading] = useState(false);
  const [smOption, setSmOption] = useState(false);
  const [data, setData] = useState([]);
  const [editId, setEditedId] = useState();
  const [timeNow, setTimeNow] = useState();
  const [deleteId, setDeleteId] = useState();
  const [view, setView] = useState({
    edit: false,
    add: false,
    isDelete: false,
  });


  const colTable = [
    {
      Header: "Mã",
      accessor: (item) => item.id,
    },
    {
      Header: "Tên",
      accessor: (item) => item.name,
    },
    {
      Header: "Địa chỉ",
      accessor: (item) => item.address,
    },
    {
      Header: "Kho thuê gia công",
      accessor: (item) => item.isOutsourcingWarehouse ? <span className="badge badge-warning">Thuê gia công</span> : null,
    },
    {
      Header: "Hành động",
      accessor: (item) => (
        <ul className="nk-tb-actions gx-1">
          <li>
            <UncontrolledDropdown>
              <DropdownToggle
                tag="a"
                className="btn btn-icon dropdown-toggle btn-trigger"
              >
                <Icon name="more-h"></Icon>
              </DropdownToggle>
              <DropdownMenu right>
                <ul className="link-list-opt no-bdr">
                  <li>
                    <DropdownItem
                      tag="a"
                      href="#edit"
                      onClick={(ev) => {
                        ev.preventDefault();
                        onEditClick(item.id);
                        toggle("edit");
                      }}
                    >
                      <Icon name="edit"></Icon>
                      <span>Cập nhật</span>
                    </DropdownItem>
                  </li>

                  <li>
                    <DropdownItem
                      tag="a"
                      href="#dropdown"
                      onClick={(ev) => {
                        ev.preventDefault();
                        setDeleteId(item.id);
                        toggle("isDelete");
                      }}
                    >
                      <Icon name="trash" className="text-danger"></Icon>
                      <span>Xoá</span>
                    </DropdownItem>
                  </li>
                </ul>
              </DropdownMenu>
            </UncontrolledDropdown>
          </li>
        </ul>
      ),
    },
  ];

  const {
    errors,
    handleSubmit,
    reset,
    getValues,
    control,
  } = useForm({
    defaultValues: {
      ...DEFAULT_WAREHOUSE,
    },
  });

  useEffect(() => {
    setLoading(true);
    setData([]);

    GET(`/warehouse`, {}, true)
      .then(({ data }) => {
        setData(data.rows);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [timeNow]);

  // toggle function to view order details
  const toggle = (type) => {
    setView({
      ...view,
      [type]: !view[type],
    });
  };

  // function to close the form modal
  const onFormCancel = () => {
    setView({ add: false, edit: false, isDelete: false });
    reset({
      ...DEFAULT_WAREHOUSE,
    });
    setEditedId();
    setDeleteId();
  };

  const resetData = () => {
    setEditedId("");
    onFormCancel();
  };

  const onEditClick = (id) => {
    setLoading(true);
    setEditedId(id);

    GET(`/warehouse/${id}`, {}, true)
      .then(({ data }) => {
        reset({
          ...data,
        });
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
        onFormCancel();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // Submits form data
  const onHandleSubmit = () => {
    setLoading(true);
    const formData = {
      ...getValues(),
      isOutsourcingWarehouse: !!getValues().isOutsourcingWarehouse,
    };
    const request = editId
      ? PUT(`/warehouse/${editId}`, formData, {}, true)
      : POST("/warehouse", formData, {}, true);

    request
      .then(() => {
        if (editId) {
          toast.success("Cập nhật thành công");
        } else {
          toast.success("Thêm thành công");
        }
        resetData();
        setTimeNow(moment().valueOf());
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const deleteTax = (id) => {
    if (!id) {
      return;
    }
    DELETE(`/warehouse/${id}`, {}, true)
      .then(() => {
        toast.success("Xóa thành công");
        resetData();
        setTimeNow(moment().valueOf());
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      });
  };

  return (
    <React.Fragment>
      <Head title="Quản lý kho"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Quản lý Kho</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div>
                        <Button
                          className="btn-primary"
                          color="primary"
                          type="button"
                          onClick={(e) => {
                            e.preventDefault();
                            onFormCancel();
                            toggle("add");
                          }}
                        >
                          <Icon name="plus"></Icon>
                          <span>Thêm kho</span>
                        </Button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="my-3">
                  <Table
                    loading={loading}
                    columns={colTable}
                    data={data}
                    notShowPagi={true}
                  ></Table>
                </div>
              </div>
            </div>
          </div>
        </Block>

        <Modal
          isOpen={view.add || view.edit}
          toggle={() => onFormCancel()}
          className="modal-dialog-centered"
          size="lg"
        >
          <ModalBody>
            <a href="#cancel" className="close">
              {" "}
              <Icon
                name="cross-sm"
                onClick={(ev) => {
                  ev.preventDefault();
                  onFormCancel();
                }}
              ></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Thêm Kho</h5>
              <div className="mt-4">
                <form onSubmit={handleSubmit(onHandleSubmit)}>
                  <Row className="g-3">
                    <Col size="12">
                      <div className="form-group">
                        <label className="form-label">
                          Mã
                          <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="id"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, ref }) => (
                              <input
                                className="form-control"
                                ref={ref}
                                value={value}
                                onChange={(e) => onChange(e.target.value)}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="id"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col size="12">
                      <div className="form-group">
                        <label className="form-label">
                          Tên
                          <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="name"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, ref }) => (
                              <input
                                className="form-control"
                                ref={ref}
                                value={value}
                                onChange={(e) => onChange(e.target.value)}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="name"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col size="12">
                      <div className="form-group">
                        <label className="form-label">
                          Địa chỉ
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="address"
                            render={({ onChange, value, ref }) => (
                              <input
                                className="form-control"
                                ref={ref}
                                value={value}
                                onChange={(e) => onChange(e.target.value)}
                              />
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col size="12">
                      <div className="form-group">
                        <Controller
                          control={control}
                          name="isOutsourcingWarehouse"
                          render={({ onChange, value }) => (
                            <div className="custom-control custom-checkbox">
                              <input
                                id="isOutsourcingWarehouse"
                                type="checkbox"
                                className="custom-control-input"
                                checked={!!value}
                                onChange={(e) => onChange(e.target.checked)}
                              />
                              <label className="custom-control-label" htmlFor="isOutsourcingWarehouse">
                                Đây là kho thuê gia công
                              </label>
                            </div>
                          )}
                        />
                      </div>
                    </Col>
                    <Col size="12">
                      <Button color="primary" type="submit" disabled={loading}>
                        <Icon className="plus"></Icon>
                        <span>Xác nhận</span>
                      </Button>
                    </Col>
                  </Row>
                </form>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={view.isDelete} toggle={() => onFormCancel()}>
          <ModalBody className="modal-body-lg text-center">
            <div className="nk-modal">
              <Icon className="nk-modal-icon icon-circle icon-circle-xxl ni ni-cross bg-danger"></Icon>
              <h4 className="nk-modal-title">
                Bạn có chắc muốn xoá kho này không ?{" "}
              </h4>
              <div className="nk-modal-action mt-5 d-flex justify-content-around">
                <Button
                  color="light"
                  size="lg"
                  className="btn-mw mr-5"
                  onClick={() => onFormCancel()}
                  disabled={loading}
                >
                  Huỷ bỏ
                </Button>
                <Button
                  color="primary"
                  size="lg"
                  className="btn-mw"
                  onClick={(ev) => {
                    ev.preventDefault();
                    deleteTax(deleteId);
                  }}
                  disabled={loading}
                >
                  Xác nhận
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </Content>
    </React.Fragment>
  );
};

export default WarehouseManager;
